import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Cómo lo recibo?',
  answer: 'Después de pagar, recibirás un correo electrónico inmediato con los enlaces de descarga directa para el eBook (PDF) y el AudioLibro (MP3). Es automático y seguro.'
}, {
  question: '¿Puedo escucharlo desde mi celular?',
  answer: 'Sí, absolutamente. Los archivos están optimizados para reproducirse en cualquier smartphone (iPhone o Android), tablet o computadora.'
}, {
  question: '¿Esto es para venezolanos solamente?',
  answer: 'No. Aunque está escrito desde la experiencia venezolana, es una lectura fundamental para cualquier persona que quiera entender con claridad histórica y humana qué pasó en Venezuela y por qué importa para el resto del mundo.'
}];
export function FAQSection() {
  return <section id="faq" className="py-10 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-8 bg-[#0a0a0a]" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-white mb-6 sm:mb-10 text-center font-serif" data-id="element-3">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-3 sm:space-y-4" data-id="element-4">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-5" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-zinc-800 rounded-lg bg-zinc-900/30 overflow-hidden" data-id="element-6">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-4 sm:p-5 text-left hover:bg-zinc-900 transition-colors" data-id="element-7">
        <span className="font-medium text-zinc-200 text-sm sm:text-base pr-4" data-id="element-8">
          {question}
        </span>
        <ChevronDown className={`text-zinc-500 transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} size={18} data-id="element-9" />
      </button>
      <AnimatePresence data-id="element-10">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-11">
            <div className="px-4 pb-4 sm:p-5 sm:pt-0 text-zinc-400 leading-relaxed border-t border-zinc-800/50 text-sm sm:text-base" data-id="element-12">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}